var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPremiumPlan2X = function SvgPremiumPlan2X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#premium-plan-2x_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 25c0 1.941-1 9.059-1 11",
    stroke: "url(#premium-plan-2x_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.346 25.587c-4.855-4.594-4.855-18.95 0-23.544 5.482 4.594 5.195 18.95 0 23.544Z",
    fill: "url(#premium-plan-2x_svg__c)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#premium-plan-2x_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.29 25.876c-2.88-5.799 2.064-18.486 8.108-20.807 3.455 6.023-1.754 18.607-8.109 20.807Z",
    fill: "url(#premium-plan-2x_svg__e)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#premium-plan-2x_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.268 25.876c2.88-5.799-2.065-18.486-8.109-20.807-3.454 6.023 1.754 18.607 8.11 20.807Z",
    fill: "url(#premium-plan-2x_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#premium-plan-2x_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.078 25.86c-.185-6.681 9.966-16.833 16.648-16.648.628 7.124-9.727 17.073-16.648 16.648Z",
    fill: "url(#premium-plan-2x_svg__i)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#premium-plan-2x_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.48 25.86C18.665 19.18 8.513 9.027 1.831 9.212 1.204 16.336 11.56 26.285 18.48 25.86Z",
    fill: "url(#premium-plan-2x_svg__k)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan-2x_svg__b",
    x1: 17.5,
    y1: 25,
    x2: 17.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#267512"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27940C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan-2x_svg__c",
    x1: 17.527,
    y1: 2.043,
    x2: 17.527,
    y2: 25.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F56C3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan-2x_svg__e",
    x1: 26.565,
    y1: 5.134,
    x2: 18.456,
    y2: 25.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F56C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE3500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan-2x_svg__g",
    x1: 8.993,
    y1: 5.134,
    x2: 17.102,
    y2: 25.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA88A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE3500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan-2x_svg__i",
    x1: 33.854,
    y1: 9.34,
    x2: 17.206,
    y2: 25.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA88A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "premium-plan-2x_svg__k",
    x1: 1.703,
    y1: 9.34,
    x2: 18.352,
    y2: 25.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE3500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FF7241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA88A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premium-plan-2x_svg__d",
    x: 15.687,
    y: 3.75,
    width: 12.692,
    height: 23.445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 0 0.0235294 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4470_14440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4470_14440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premium-plan-2x_svg__f",
    x: 6.298,
    y: 3.75,
    width: 12.692,
    height: 23.445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 0 0.0235294 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4470_14440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4470_14440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premium-plan-2x_svg__h",
    x: 15.316,
    y: 7.89,
    width: 19.317,
    height: 19.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 0 0.0235294 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4470_14440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4470_14440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "premium-plan-2x_svg__j",
    x: 0.045,
    y: 7.89,
    width: 19.317,
    height: 19.303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.44
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.66
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.431373 0 0 0 0 0.129412 0 0 0 0 0.0235294 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4470_14440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4470_14440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "premium-plan-2x_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgPremiumPlan2X;